import { apiFetch } from "@/api/client";

export interface GrafanaConfig {
  configured: boolean;
  base_url: string | null;
}

export const fetchGrafanaConfig = () => apiFetch<GrafanaConfig>("/grafana/config");
